/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_Row1Inputs */

const en_mk_proof_panel_row1 = /** @type {(inputs: Mk_Proof_Panel_Row1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pnpm test — 24 passed`)
};

const id_mk_proof_panel_row1 = /** @type {(inputs: Mk_Proof_Panel_Row1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pnpm test — 24 lulus`)
};

/**
* | output |
* | --- |
* | "pnpm test — 24 passed" |
*
* @param {Mk_Proof_Panel_Row1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_row1 = /** @type {((inputs?: Mk_Proof_Panel_Row1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_Row1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_row1(inputs)
	return en_mk_proof_panel_row1(inputs)
});